<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR CONFIGURAÇÃO DE HORÁRIO' : 'NOVA CONFIGURAÇÃO DE HORÁRIO'" titleIcon="fas fa-clock">

            <div v-if="!carregado" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <el-form v-else label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">

                <el-alert type="info" :closable="false" class="u-mb-15"
                    title="Marque os dias e monte a grade de cada um. Intervalo não é aula: ele ocupa horário, mas nunca recebe componente no quadro. O sábado só passa a valer se for marcado aqui."></el-alert>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]">
                            <el-input v-model="dados.nome" placeholder="Ex.: Matutino — Fundamental"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Escola">
                            <el-select v-model="dados.instituicao_id" filterable clearable placeholder="Toda a rede" style="width: 100%;">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="3">
                        <el-form-item label="Turno">
                            <el-select v-model="dados.turno" clearable placeholder="Todos" style="width: 100%;">
                                <el-option v-for="t in turnos" :key="t.v" :value="t.v" :label="t.l"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="3">
                        <el-form-item label="Situação">
                            <el-select v-model="dados.situacao" style="width: 100%;">
                                <el-option :value="true" label="Ativa"></el-option>
                                <el-option :value="false" label="Inativa"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Período letivo" prop="periodo_letivo_id" :rules="[$requiredChange]">
                            <el-select v-model="dados.periodo_letivo_id" style="width: 100%;">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="16">
                        <el-form-item label="Dias da semana">
                            <el-checkbox-group v-model="dados.dias_semana" @change="sincronizarDias">
                                <el-checkbox v-for="(nome, idx) in nomeDoDia" :key="idx" :label="idx" border size="small">{{ nome }}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div v-for="dia in diasOrdenados" :key="'d' + dia" class="u-mb-20">
                    <h4 class="u-mb-10">{{ nomeDoDia[dia] }}</h4>

                    <div class="container-table">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th style="width: 90px;">Ordem</th>
                                    <th style="width: 150px;">Tipo</th>
                                    <th style="width: 130px;">Início</th>
                                    <th style="width: 130px;">Fim</th>
                                    <th style="width: 90px;" class="u-text-center">Ação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(linha, idx) in dados.aulas[dia]" :key="'l' + dia + '-' + idx">
                                    <td><el-input v-model="linha.ordem" v-mask="'##'" size="mini"></el-input></td>
                                    <td>
                                        <el-select v-model="linha.tipo" size="mini" style="width: 100%;">
                                            <el-option value="aula" label="Aula"></el-option>
                                            <el-option value="intervalo" label="Intervalo"></el-option>
                                        </el-select>
                                    </td>
                                    <td><el-input v-model="linha.hora_inicio" v-mask="'##:##'" size="mini" placeholder="07:00"></el-input></td>
                                    <td><el-input v-model="linha.hora_fim" v-mask="'##:##'" size="mini" placeholder="07:50"></el-input></td>
                                    <td class="u-text-center">
                                        <el-button @click="removerLinha(dia, idx)" title="Remover" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                    </td>
                                </tr>
                                <tr v-if="!dados.aulas[dia] || !dados.aulas[dia].length">
                                    <td colspan="5" class="u-text-center">Nenhuma linha. Adicione ao menos uma aula.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <el-button @click="adicionarLinha(dia)" size="mini" icon="el-icon-plus" class="u-mt-10">ADICIONAR LINHA</el-button>
                    <el-button v-if="diasOrdenados.length > 1" @click="replicarPara(dia)" size="mini" icon="el-icon-copy-document" class="u-mt-10 u-ml-10">REPLICAR PARA OS DEMAIS DIAS</el-button>
                </div>

                <div class="u-text-right u-mt-20">
                    <router-link to="/admin/configuracao-horario"><el-button>CANCELAR</el-button></router-link>
                    <el-button class="u-ml-10" type="primary" native-type="submit">SALVAR</el-button>
                </div>
            </el-form>
        </c-panel>
    </div>
</template>
<script>
/**
 * BLOCO F — itens 11 e 105 do edital (Timbé do Sul/SC). Fase F10.
 *
 * O usuário vê NOMES de dia; a convenção 0..6 do backend fica só no valor.
 *
 * Nenhuma validação de negócio é duplicada aqui: sobreposição de horários, ordem
 * repetida, dia com só intervalo e unicidade de escopo são verificados pelo
 * `ConfiguracaoHorarioService` e a mensagem dele é exibida como veio.
 */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        carregado: false,
        nomeDoDia: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        turnos: [{ v: 0, l: 'Matutino' }, { v: 1, l: 'Vespertino' }, { v: 2, l: 'Noturno' }, { v: 4, l: 'Integral' }],
        instituicoes: [],
        dados: {
            nome: '', instituicao_id: null, periodo_letivo_id: null, turno: null,
            dias_semana: [], aulas: {}, situacao: true
        }
    }),
    computed: {
        modoEdicao () { return !!this.$route.params.id },
        diasOrdenados () { return this.dados.dias_semana.slice().sort((a, b) => a - b) }
    },
    mounted () {
        this.dados.periodo_letivo_id = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        // `initForm` do Bloco F devolve os rótulos de dia e os tipos de linha. A lista de
        // escolas vem de `api/instituicao/getAll`, o mesmo endpoint que a tela de
        // configuração de frequência (Bloco B) já usa — sem endpoint novo.
        this.$axios.get(
            `${this.$store.state.config.baseUrlApi}/api/configuracao-horario/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => {
            const d = r.data || {}
            if (Array.isArray(d.dias_semana) && d.dias_semana.length) {
                d.dias_semana.forEach(x => { this.nomeDoDia[parseInt(x.v)] = x.l })
            }
        }).catch(() => {})

        this.$axios.get(
            `${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})

        if (this.modoEdicao) this.carregarRegistro()
        else this.carregado = true
    },
    methods: {
        carregarRegistro () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/configuracao-horario/getById/${this.$route.params.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                if (reg.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(reg.erro), type: 'warning' })
                    this.$router.push('/admin/configuracao-horario')
                    return
                }
                this.dados.nome = reg.nome
                this.dados.instituicao_id = reg.instituicao_id
                this.dados.periodo_letivo_id = reg.periodo_letivo_id
                this.dados.turno = reg.turno
                this.dados.situacao = reg.situacao !== false
                this.dados.dias_semana = (reg.dias_semana || []).map(d => parseInt(d))
                const aulas = {}
                Object.keys(reg.aulas || {}).forEach(dia => { aulas[parseInt(dia)] = reg.aulas[dia] })
                this.dados.aulas = aulas
                this.sincronizarDias()
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        sincronizarDias () {
            const novo = {}
            this.dados.dias_semana.forEach(d => { novo[d] = this.dados.aulas[d] || [] })
            this.$set(this.dados, 'aulas', novo)
        },
        adicionarLinha (dia) {
            if (!this.dados.aulas[dia]) this.$set(this.dados.aulas, dia, [])
            const proxima = this.dados.aulas[dia].length + 1
            this.dados.aulas[dia].push({ tipo: 'aula', ordem: proxima, hora_inicio: '', hora_fim: '' })
        },
        removerLinha (dia, idx) { this.dados.aulas[dia].splice(idx, 1) },
        replicarPara (dia) {
            const modelo = JSON.parse(JSON.stringify(this.dados.aulas[dia] || []))
            this.dados.dias_semana.forEach(d => { if (d !== dia) this.$set(this.dados.aulas, d, JSON.parse(JSON.stringify(modelo))) })
            window.eventBus.$emit('alert', { msg: 'Grade replicada para os demais dias marcados.', type: 'success' })
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/configuracao-horario/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/configuracao-horario/store`

                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Configuração salva.', type: 'success' })
                    this.$router.push('/admin/configuracao-horario')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        textoErro (erro) { return typeof erro === 'string' ? erro : (erro.text || 'Não foi possível concluir.') }
    }
}
</script>
